import React, { useContext, useState } from 'react'
import { AuthContext } from '../contexts/AuthContext'
import { Bolt, Email, Moped, TwoWheeler, Wallet } from '@mui/icons-material';
import { Api } from '../contexts/Api';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { jwtDecode } from 'jwt-decode';

function EditProfile() {
    const navigate = useNavigate();
    const { profile } = useContext(AuthContext);
    const { productsCount, ordersCount, ordersRevenue } = useContext(Api);
    const [profileDetail, setProfileDetail] = useState(profile);
    const [password, setPassword] = useState({
        current_password: '',
        new_password: '',
        confirm_password: '',
    });
    const [cookies, setCookie, removeCookie] = useCookies(['tokenProf']);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setProfileDetail((prev) => ({
            ...prev,
            [name]: value,
        }));
        console.log(profileDetail)
    };

    const handlePasswordInputChange = (e) => {
        const { name, value } = e.target;
        setPassword((prev) => ({
            ...prev,
            [name]: value,
        }));
        console.log(profileDetail)
    };
    const handleChangePassword = async () => {
        // Yeni şifrə və təsdiq şifrəsinin uyğunluğunu yoxla
        if (password.new_password !== password.confirm_password) {
            alert("New password and confirmation password do not match!");
            return;
        }


        try {
            // Backend-ə POST sorğusu göndər
            const response = await axios.post('https://elnaf.fi/apiElnaf/api/changePassword.php', {
                id: profileDetail.id, // Token-dən istifadəçi ID-sini əldə et
                current_password: password.current_password,
                new_password: password.new_password,
            });

            // Cavabı yoxla
            if (response.data.status === 'success') {
                alert("Password changed successfully!");
                setPassword({
                    current_password: '',
                    new_password: '',
                    confirm_password: '',
                });
            } else {
                alert(response.data.message || "The password could not be changed.");
            }
        } catch (error) {
            console.error("Xəta:", error);
            alert("An error occurred. Please try again.");
        }
    };
    const handleSave = () => {
        if (profileDetail && profileDetail.id && (profileDetail.username || profileDetail.email)) {

            axios.post('https://elnaf.fi/apiElnaf/api/editProfile.php', JSON.stringify(profileDetail), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            })
                .then(response => {
                    const data = response.data;

                    if (data.status === 'success') {
                        const jwtUser = jwtDecode(data.token);
                        console.log(jwtUser.exp)
                        setCookie('tokenProf', data.token, { path: '/', expires: new Date(jwtUser.exp * 1000) });
                        alert('Profile updated successfully!');
                        navigate('/profile');
                    } else {
                        alert('Error: ' + data.message);
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }
    return (
        <div className="row">
            <div className="col-xl-3">
                <div className="card custom-card">
                    <div className="card-header justify-content-between">
                        <div className="card-title"> Change Password </div>
                    </div>
                    <div className="card-body">
                        <div className="row gy-3">
                            <div className="col-xl-12"> <label htmlFor="current_password" className="form-label">Current
                                Password :</label>
                                <input type="text" className="form-control" onChange={handlePasswordInputChange} value={password.current_password} name='current_password' placeholder="Enter Password..." /> </div>
                            <div className="col-xl-12"> <label htmlFor="new_password" className="form-label">New Password
                                :</label>
                                <input type="text" className="form-control" onChange={handlePasswordInputChange} value={password.new_password} name='new_password' placeholder="Enter Password..." /> </div>
                            <div className="col-xl-12"> <label htmlFor="confirm_password" className="form-label">Confirm
                                Password :</label>
                                <input type="text" className="form-control" onChange={handlePasswordInputChange} value={password.confirm_password} name='confirm_password' placeholder="Enter Password..." /> </div>
                        </div>
                    </div>
                    <div className="card-footer text-end">
                        <button onClick={handleChangePassword} disabled={!(password && password.current_password && password.new_password && password.confirm_password && (password.new_password === password.confirm_password))} className="btn btn-primary btn-wave waves-effect waves-light"> Update </button>
                    </div>
                </div>
            </div>
            <div className="col-xl-9">
                <div className="card custom-card">
                    <div>
                        <div className="profile-banner-img">
                            <img src="assets/images/media/media-74.jpg" className="rounded w-100" alt="..." />
                        </div>
                        <div className="mt-4 mb-0 p-4 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                            <div>
                                <h5 className="fw-semibold mb-3">{profile.full_name || 'No Name'}</h5>
                                <span className="d-block fw-medium text-muted mb-1">{profile.position || 'Position not assigned'}</span>
                                <p className="fs-12 mb-0 fw-medium text-muted"> <span className="me-3">{profile.email}</span>
                                </p>
                            </div>
                            <div className="d-flex mb-0 flex-wrap gap-4">
                                <div className="py-2 ps-2 pe-3 rounded-pill d-flex align-items-center border gap-3">
                                    <div className="main-card-icon primary">
                                        <div className="avatar avatar-md avatar-rounded bg-primary-transparent svg-primary border border-primary border-opacity-25">
                                            <Bolt />
                                        </div>
                                    </div>
                                    <div>
                                        <p className="fw-semibold h6 mb-0">{productsCount}</p>
                                        <p className="mb-0 fs-12 text-muted fw-medium">Products</p>
                                    </div>
                                </div>
                                <div className="py-2 ps-2 pe-3 rounded-pill d-flex align-items-center border  gap-3">
                                    <div className="main-card-icon secondary">
                                        <div className="avatar avatar-rounded avatar-md bg-secondary-transparent svg-secondary border border-secondary border-opacity-25">
                                            <Moped />
                                        </div>
                                    </div>
                                    <div>
                                        <p className="fw-semibold h6 mb-0">{ordersCount}</p>
                                        <p className="mb-0 fs-12 text-muted fw-medium">Total Orders</p>
                                    </div>
                                </div>
                                <div className="py-2 ps-2 pe-3 rounded-pill d-flex align-items-center border gap-2">
                                    <div className="main-card-icon success">
                                        <div className="avatar avatar-rounded avatar-md bg-success-transparent svg-success border border-success border-opacity-25">
                                            <Wallet />
                                        </div>
                                    </div>
                                    <div>
                                        <p className="fw-semibold h6 mb-0">€{ordersRevenue}</p>
                                        <p className="mb-0 fs-12 text-muted fw-medium">Earning</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="p-3 border-bottom border-top border-block-end-dashed tab-content">
                        <div className="tab-pane show active overflow-hidden p-0 border-0" id="account-pane" role="tabpanel" aria-labelledby="account" tabIndex={0}>
                            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-1">
                                <div className="fw-semibold d-block fs-15">Account Settings :</div>
                            </div>
                            <div className="row gy-3">

                                <div className="col-xl-6">
                                    <label htmlFor="full_name" className="form-label">Full Name :</label>
                                    <input type="text" className="form-control" onChange={handleInputChange} value={profileDetail.full_name} name='full_name' placeholder="Enter Full Name" />
                                </div>
                                <div className="col-xl-6">
                                    <label htmlFor="email" className="form-label">Email :</label>
                                    <input type="email" className="form-control" name='email' onChange={handleInputChange} value={profileDetail.email} placeholder="Enter Email" />
                                </div>
                                <div className="col-xl-6">
                                    <label htmlFor="username" className="form-label">Username :</label>
                                    <input type="text" className="form-control" name='username' onChange={handleInputChange} value={profileDetail.username} placeholder="Enter Username" />
                                </div>
                                <div className="col-xl-6">
                                    <label htmlFor="position" className="form-label">Position :</label>
                                    <input type="text" className="form-control" name='position' onChange={handleInputChange} value={profileDetail.position} placeholder="Enter Position" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer border-top-0">
                        <div className="btn-list float-end">
                            <button disabled={!(profileDetail && (profileDetail.username || profileDetail.email))} onClick={handleSave} className="btn btn-primary btn-wave">Save Changes</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default EditProfile